import { render, staticRenderFns } from "./MoskitoPieScore.vue?vue&type=template&id=caacc2a8&"
import script from "./MoskitoPieScore.vue?vue&type=script&lang=js&"
export * from "./MoskitoPieScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports